import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import html from "../assets/img/html.png";
import css3 from "../assets/img/css-3.png";
import cplusplus from "../assets/img/c-.png";
import figma from "../assets/img/figma.png";
import git from "../assets/img/git.png";
import java from "../assets/img/java.png";
import js from "../assets/img/js.png";
import react from "../assets/img/atom.png";
import database from "../assets/img/database.png";
import bootstrap from "../assets/img/bootstrap.png";
import github from "../assets/img/github.svg";
import mongodb from "../assets/img/mongodb.svg";
import intellijidea from "../assets/img/intellijidea.svg";
import eclipse from "../assets/img/eclipse.svg";
import vscode from "../assets/img/vs-code.svg";
import androidstudio from "../assets/img/androidstudio.svg";
import kotlin from "../assets/img/kotlin.svg";
import kanban from "../assets/img/trello.svg";
import firebase from "../assets/img/firebase.svg";
import spring from "../assets/img/spring.svg";
import rStudio from "../assets/img/rstudio.svg";
import postman from "../assets/img/postman.svg";
import colorSharp from "../assets/img/color-sharp.png";

const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx">
              <h2>Tools & Technologies</h2>
              <p>
                Proficient in front-end and back-end technologies, I bring ideas
                to life through clean and efficient code.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="skill-slider"
              >
                <div className="item">
                  <img src={html} alt="HTML5" />
                  <h5>HTML5</h5>
                </div>
                <div className="item">
                  <img src={css3} alt="css3" />
                  <h5>CSS3</h5>
                </div>
                <div className="item">
                  <img src={cplusplus} alt="C++" />
                  <h5>C++</h5>
                </div>
                <div className="item">
                  <img src={git} alt="git" />
                  <h5>Git</h5>
                </div>
                <div className="item">
                  <img src={github} alt="Github" />
                  <h5>Github</h5>
                </div>
                <div className="item">
                  <img src={java} alt="java" />
                  <h5>Java</h5>
                </div>
                <div className="item">
                  <img src={spring} alt="spring" />
                  <h5>SpringBoot</h5>
                </div>
                <div className="item">
                  <img src={kotlin} alt="kotlin" />
                  <h5>Kotlin</h5>
                </div>
                <div className="item">
                  <img src={js} alt="js" />
                  <h5>Js</h5>
                </div>
                <div className="item">
                  <img src={react} alt="react" />
                  <h5>React</h5>
                </div>
                <div className="item">
                  <img src={database} alt="database" />
                  <h5>SQL</h5>
                </div>
                <div className="item">
                  <img src={mongodb} alt="MongoDB database" />
                  <h5>MongoDB</h5>
                </div>
                <div className="item">
                  <img src={firebase} alt="firebase database" />
                  <h5>Firebase</h5>
                </div>
                <div className="item">
                  <img src={bootstrap} alt="bootstrap" />
                  <h5>Bootstrap</h5>
                </div>
                <div className="item">
                  <img src={figma} alt="Figma" />
                  <h5>Figma</h5>
                </div>
                <div className="item">
                  <img src={kanban} alt="kanban" />
                  <h5>Kanban</h5>
                </div>
                <div className="item">
                  <img src={intellijidea} alt="intellijidea" />
                  <h5>Intellijidea</h5>
                </div>
                <div className="item">
                  <img src={eclipse} alt="eclipse" />
                  <h5>Eclipse</h5>
                </div>
                <div className="item">
                  <img src={androidstudio} alt="androidstudio" />
                  <h5>Androidstudio</h5>
                </div>
                <div className="item">
                  <img src={vscode} alt="vscode" />
                  <h5>Vscode</h5>
                </div>
                <div className="item">
                  <img src={rStudio} alt="rstudio" />
                  <h5>Rstudio</h5>
                </div>
                <div className="item">
                  <img src={postman} alt="postman" />
                  <h5>Postman</h5>
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
      <img className="background-image-left" src={colorSharp} />
    </section>
  );
};

export default Skills;
